<div (contextmenu)="onRightClick($event)">
    <!-- main app container -->
    <div #loadingContainer class="modal fade pop_Loading in" tabindex="-1" role="dialog" aria-hidden="true"
        [class.display-block]="display" [class.display-none]="!display">
        <div class="modal-dialog">
            <div class="modal-content ct">
                <div class="txt">LOADING</div>
                <div class="pic">
                    <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-backdrop fade in" *ngIf="display"></div>

    <popup [header]="systemPopupTitle" id="systemMessage" modal="modal" [closable]="false" [height]="systemPopupHeight"
        [contentHeight]="systemPopupContentHeight" [width]="systemPopupWidth" [(visible)]="systemDisplay"
        [dismissableMask]="false" [closable]="false" [draggable]="false" [closeOnEscape]="false" [resizable]="false"
        responsive="true">


        <div class="modal_area">
            <div class="warring_area mar_top20"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                <span>{{systemPopupLabel}}</span>
                <div [innerHTML]="systemMessage | safeHtml"></div>
            </div>

            <div class="btn_box">
                <commandButton [mask]="false" (onClick)="closeSystemPopup()">{{systemButtonName}}</commandButton>
            </div>
        </div>


    </popup>

    <suspend-popup [display]="suspendDisplay" [viewForm]="suspendViewForm" (closeCallback)="closeCallback($event)"
        (confirmCallback)="confirmCallback($event)">
    </suspend-popup>

    <softtoken-tx-verify-popup [display]="softTokenTxVerifyDisplay" [viewForm]="softTokenTxVerifyViewForm"
        (closeCallback)="closeSoftTokenTxVerifyCallback($event)">
    </softtoken-tx-verify-popup>

    <router-outlet></router-outlet>
    <!-- 全系統共用隱藏的IFrame, 不可變更id和name -->
    <div class="hidden-zero-height">
        <!--  用來計算dropdownCell的寬度 -->
        <div class="ui-dropdown ui-widget ui-state-default ui-corner-all ui-helper-clearfix" id="uiDropdownCellTmp">
            <label class="ui-dropdown-label ui-inputtext ui-corner-all " id="dropdownCellTmp">
            </label>
        </div>
    </div>

</div>